import React from 'react'
import { Media } from 'reactstrap'
import ShowMore from './ShowMore'

import Stars from './Stars'

const CardReview = (props) => {
  const { data } = props
  const avatarImg = (
    <img
      className='avatar avatar-border-white overflow-hidden'
      src={data.owner.avatar ?? '/content/img/avatar/dummy-user.jpg'}
      alt={data.owner.name_display}
      layout='fixed'
    />
  )
  return (
    <Media className='d-block d-sm-flex review'>
      <div className='text-md-center mr-4 mr-xl-5'>
        {avatarImg}
        {/* <span className="test-first-letter text-muted text-sm">
                    {data.date}
                </span> */}
      </div>
      <Media body>
        <h6 className='mt-2 mb-1'>{data.owner.name_display}</h6>
        <div className='mb-2'>
          <Stars size='xs' stars={data.score} />
        </div>
        <ShowMore lines={3} value={data.comment} containerClass='text-muted' />
      </Media>
    </Media>
  )
}

export default CardReview
